/* eslint-disable no-bitwise */

// https://github.com/FlutterInt/fips-shared-protocols/blob/master/tourndef.h

// prettier-ignore
enum TournFlags {
  TOURNSCRIPT_FLAG_USETICKETORBUYIN = 1 << 0,         // 0x0001
  TOURNSCRIPT_FLAG_OLYMPICHACK = 1 << 1,              // 0x0002
  TOURNSCRIPT_FLAG_SITANDGO_EXTRA = 1 << 2,           // 0x0004
  TOURNSCRIPT_FLAG_DOUBLESTAKES = 1 << 3,             // 0x0008
  TOURNSCRIPT_FLAG_SITANDGO = 1 << 4,                 // 0x0010
  TOURNSCRIPT_FLAG_PPA = 1 << 5,                      // 0x0020
  TOURNSCRIPT_FLAG_REGENERATED = 1 << 6,              // 0x0040
  TOURNSCRIPT_FLAG_CHIPSDENOMINATION = 1 << 7,        // 0x0080
  TOURNSCRIPT_FLAG_NOTELIGIBLEBOARD = 1 << 8,         // 0x0100
  TOURNSCRIPT_FLAG_AFTERFINISHED = 1 << 9,            // 0x0200
  TOURNSCRIPT_FLAG_NO_HOMEGAME_STATS = 1 << 10,       // 0x0400
  TOURNSCRIPT_FLAG_STOPSATELLITE = 1 << 11,           // 0x0800
  TOURNSCRIPT_FLAG_EXTENDEDREGISTRATION = 1 << 12,    // 0x1000
  TOURNSCRIPT_FLAG_RECORDING = 1 << 13,               // 0x2000
  TOURNSCRIPT_FLAG_RECOPENCARDS = 1 << 14,            // 0x4000
  TOURNSCRIPT_FLAG_NOTSAVEHANDSTODBM = 1 << 15,       // 0x8000
  TOURNSCRIPT_FLAG_HIGHVOLUMEREG = 1 << 16,           // 0x10000
  TOURNSCRIPT_FLAG_REBUYENABLE = 1 << 17,             // 0x20000
  TOURNSCRIPT_FLAG_ADDONENABLE = 1 << 18,             // 0x40000
  TOURNSCRIPT_FLAG_SATELLITERETURNBUYIN = 1 << 19,    // 0x80000
  TOURNSCRIPT_FLAG_DUMMY = 1 << 20,                   // 0x100000
  TOURNSCRIPT_FLAG_NOOBSERVCHATONTHEEND = 1 << 21,    // 0x200000
  TOURNSCRIPT_FLAG_BLOCKCHATALLIN = 1 << 22,          // 0x400000
  TOURNSCRIPT_FLAG_BLOCKCHATINHAND = 1 << 23,         // 0x800000
  TOURNSCRIPT_FLAG_GIVETARGETTICKET = 1 << 24,        // 0x1000000
  TOURNSCRIPT_FLAG_GIVETARGETTICKET_REG = 1 << 25,    // 0x2000000
  TOURNSCRIPT_FLAG_CHATMONITOR = 1 << 26,             // 0x4000000
  TOURNSCRIPT_FLAG_TICKETEXCLUSIVE = 1 << 27,         // 0x8000000
  TOURNSCRIPT_FLAG_BLINDSREVERSE = 1 << 28,           // 0x10000000
  TOURNSCRIPT_FLAG_NO_SATELL_WINNER_UNREG = 1 << 29,  // 0x20000000
  TOURNSCRIPT_FLAG_REGISTERTOSIMILAR = 1 << 30,       // 0x40000000
  // TOURNSCRIPT_FLAG_END (1 << 31)                   // 0x80000000 // The End!
}

export default TournFlags;
